module.exports = __webpack_public_path__ + "static/media/ic_question_blue.cb4bd0e7.svg";